<app-title-header [title]="'title.dashboard.welcome' | translate">
  <div class="actions-container">

    <app-global-search></app-global-search>

    <button type="button" class="create-btn" (click)="openCreateCasePopup()">
      <div>{{ 'buttons.create_new_case' | translate }} </div>
      <i class="bi bi-chevron-down"></i>
    </button>
  </div>
</app-title-header>

<div class="grid-container">
  @for (card of cardsList; track card) {
  <app-statistic-card
    class="card-component"
    [value]="card.value"
    [description]="card.description"
    [iconClass]="card.iconClass"
    [color]="card.color"
    [type]="card.type"
    [ngClass]="{'active-card': dashboardDataTableState.tableType === card.type}"
    (activeTypeEvent)="getActiveType($event)"
  ></app-statistic-card>
  }
</div>

<div class="table-wrapper">
  <app-dynamic-table
    *ngIf="isDataTableReady"
    [tableSizeClass]="'dashboard-page-table'"
    [columns]="columns"
    [rows]="cases"
    [useExternalApi]="true"
    [totalCount]="totalCount"
    [dataTableState]="dashboardDataTableState"
    [datatableDisplayAllNames]="datatableDisplayAllNames"
    [showColumnsSettingsBtn]="true"
    [filters]="filters"
    [showSaveDatatableFilterBtn]="true"
    [showExportDataBtn]="true"
    [exportDataApiPath]="'/v1/export/grid'"
    [gridSettingsChanged]="!!dashboardDatatableStateFromStorage"
    [defaultColumns]="defaultColumns"
    [selectedFilterName]="selectedFilterName"
    (dataTableStateEvent)="getDataTableState($event)"
    (saveDataTableSettingsEvent)="onSaveDatatableSettings($event)"
    (updateDataTableSettingsEvent)="onUpdateDatatableSettings($event)"
    (linkedValueClickEvent)="getLinkedValue($event)"
  ></app-dynamic-table>
</div>


<div class="news-and-announcements">
  <app-case-form-section-container [iconClass]="'bi bi-newspaper'" [title]="'label.news_and_announcements'" [navigationLink]="{label: 'label.view_all_news', link: 'news-announcements'}">
    <app-news-preview [news]="news"></app-news-preview>
  </app-case-form-section-container>
</div>
